export enum KeySide {
    up,
    down,
    left,
    right,
    stop,
    block
  }
  